/* eslint-disable quotes */
<template>
    <div>
        <nav-bar />
        <!--blog Section start-->
        <div class="page-margin">
            <!--breadcrumb start-->
            <div class="breadcrumb-bg">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-text-center d-align-center">
                            <h2 class="title"><span>Xtreme RMS</span></h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pdfcontainer flex small-screen">
            <iframe src="https://xtremecontrols.co.uk/carepdf/" frameborder="0" class="care-container"></iframe>
        </div>
        <b-button class="mx-auto d-block mt-5" variant="secondary" href="https://xtremecontrols.co.uk/carepdf/Xtreme_Care_brochure.pdf" target="_blank">Download our PDF</b-button>
    </div>
</template>
<script>
// eslint-disable-next-line quotes
import NavBar from "../components/navbar.vue"

export default {
    name: "care",
    components: {
        NavBar
    },
    mounted () {}
}
</script>
<style>
iframe {
    overflow: hidden;
}

.btn {
    color: #000000;
}

.carePDF {
    overflow: hidden;
}

.care-container {
    overflow: hidden;
    height: 78vh;
    width: calc(102vw - 5px);
}

.pdfcontainer {
    overflow: hidden;
    margin-left: -8px;
    margin-top: -8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/care.vue